const state = {
    posts: [],
    drafts: [],
    currentPost: {},
    userPosts: [],
    reachedBottom: false,
    draftsReachedBottom: false
}

export default state